<script lang="ts">
	import SettingsRenderer from 'src/components/Settings/shared/SettingsRenderer.svelte';
	import { generalSettingsConfig } from 'src/configs/settings/GeneralSettingsConfig';
</script>

<SettingsRenderer config={generalSettingsConfig.v2} variant="v2" groupContainerClass="mb-s" />
